import ChatsRowItem from './ChatsRowItem';
import { useEffect, useRef } from 'react';
import { SearchInput } from '@/components/UI/Common/SearchInput';
import { useBreakpoints } from '@/hooks/useBreakpoints';

interface ChatsListHeaderProps {
  onSearch?: (value: string) => void;
}

const ChatsListHeader = ({ onSearch }: ChatsListHeaderProps) => {
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onSearch?.(value);
    }, 300);
  };

  return (
    <ChatsRowItem
      id="chats-list-header"
      className="flex h-auto bg-white px-4 py-4 max-md:!items-start max-md:flex-col max-md:gap-3 md:sticky md:top-0 md:z-10 md:h-14 md:gap-2 md:px-4 md:py-0 xl:px-5"
    >
      {isMobile && <div className="font-semibold text-2xl">Сообщения</div>}
      <SearchInput placeholder="Поиск" onChange={handleChange} />
    </ChatsRowItem>
  );
};

export default ChatsListHeader;
